<template>
  <wa-page-focused
    decorative-icon-name="faBlockQuestion"
    theme="warning"
    title="Sorry, We Don't Sell That"
    :custom-style="{
      '--fa-primary-color': 'var(--white)',
      '--fa-secondary-color': 'var(--fa-navy)'
    }"
  >
    <p
      slot="copy"
      class="margin-bottom-2xl"
    >
      You're trying to view a product that we don't offer currently. Think we should?
      <a
        href="mailto:hello@fontawesome.com?subject=I have a product idea, Font Awesome"
        @click="supportLinkClicked('icon_commission_not_found_view')"
        >Let us know</a
      >
      .
    </p>

    <p
      slot="tip"
      class="text-center"
    >
      Confused or is something missing?
      <a
        href="mailto:hello@fontawesome.com?subject=I can't find a product, Font Awesome"
        @click="supportLinkClicked('icon_commission_not_found_view')"
        >Get in touch</a
      >
      .
    </p>
  </wa-page-focused>
</template>

<script>
  import { EventTrackingMixin } from 'app/mixins'

  export default {
    name: 'LicenseSock',

    mixins: [EventTrackingMixin]
  }
</script>
